import React, { FunctionComponent, useEffect } from 'react';
import FullPageWrapper from 'scenes/common/components/FullPageWrapper/FullPageWrapper';
import { ImportantUpdate } from 'scenes/importantUpdate/ImportantUpdate';
import { FooterTop } from 'scenes/common/components/Footer';
import { InsuranceName } from 'scenes/common/types';

const ImportantUpdateFullPage: FunctionComponent = () => {
  useEffect(() => {
    document.title = `Update | Coles Insurance`;
  }, []);

  return (
    <FullPageWrapper
      onClickCallUs={() => {}}
      isLoading={false}
      Footer={() => (
        <FooterTop
          quoteNumber=""
          pageNotLoadingOrError={false}
          showQuoteInformation={false}
          showFooterQuoteInformation={false}
          showFlybuys={false}
          showMarketingCampaign={false}
          informationLinks={[]}
          insuranceName={InsuranceName.Car}
        />
      )}
    >
      <ImportantUpdate />
    </FullPageWrapper>
  );
};

export default ImportantUpdateFullPage;
